import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import TemplateFormModal from '../../../components/change-insights/templates/TemplateFormModal/index.jsx';
import Templates from '../../../components/change-insights/templates/Templates.jsx';
import { getOrgTermsContent } from '../../../content/utils.js';
import {
  deleteTemplate,
  retrieveTemplates,
  selectTemplates,
} from '../../../modules/templates.js';

const mapStateToProps = (state) => ({
  templates: selectTemplates(state),
});

const mapDispatchToProps = { deleteTemplate, retrieveTemplates };

function TemplatesContainer({
  deleteTemplate,
  retrieveTemplates,
  templates,
  isArchivedProject,
}) {
  const [formTemplateId, setFormTemplateId] = useState(null);
  const [showFormModal, setShowFormModal] = useState(false);

  useEffect(() => {
    retrieveTemplates();
  }, [retrieveTemplates]);

  const onAddTemplate = useCallback(() => {
    if (isArchivedProject) {
      window.alert(getOrgTermsContent('archivedProjectMessage'));
    } else {
      setFormTemplateId(null);
      setShowFormModal(true);
    }
  }, []);

  const onDeleteTemplate = useCallback(
    (templateId) => {
      if (isArchivedProject) {
        window.alert(getOrgTermsContent('archivedProjectMessage'));
      } else {
        if (
          !window.confirm(
            'Are you sure you want to delete this ChangeSync template?'
          )
        )
          return;
        deleteTemplate(templateId);
      }
    },
    [deleteTemplate]
  );

  const onEditTemplate = useCallback((templateId) => {
    if (isArchivedProject) {
      window.alert(getOrgTermsContent('archivedProjectMessage'));
    } else {
      setFormTemplateId(templateId);
      setShowFormModal(true);
    }
  }, []);

  const onHideModal = useCallback(() => {
    setShowFormModal(false);
  }, []);

  if (!templates) return null;

  return (
    <React.Fragment>
      <Templates
        onAddTemplate={onAddTemplate}
        onDeleteTemplate={onDeleteTemplate}
        onEditTemplate={onEditTemplate}
        templates={templates}
      />
      <TemplateFormModal
        templateId={formTemplateId}
        onHide={onHideModal}
        show={showFormModal}
      />
    </React.Fragment>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TemplatesContainer);
